import script from "./Account.vue?vue&type=script&lang=ts&setup=true"
export * from "./Account.vue?vue&type=script&lang=ts&setup=true"

import "./Account.vue?vue&type=style&index=0&id=5d2945fc&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d2945fc"]])

export default __exports__